export const services = [
  {
    id: 1,
    title: "US Trademark Registration",
    subtitle: "Federal Brand Protection",
    description: "Lock in exclusive nationwide rights to your brand name, logo, or slogan. Our trademark attorneys file directly with the USPTO, handle office actions, and monitor your application through every stage until your certificate arrives.",
    icon: "Shield",
    features: [
      "Direct USPTO application filing",
      "Attorney-reviewed trademark search",
      "Office action response included",
      "Federal registration certificate"
    ]
  },
  {
    id: 2,
    title: "Copyright Registration",
    subtitle: "Creative Work Protection",
    description: "Guard your original content, product photos, marketing materials, and digital assets with official US Copyright Office registration. A must-have for creators and e-commerce sellers who invest in content.",
    icon: "FileText",
    features: [
      "US Copyright Office filing",
      "Digital content protection",
      "Infringement enforcement rights",
      "Copyright certificate issuance"
    ]
  },
  {
    id: 3,
    title: "Company Formation",
    subtitle: "LLC & Corporation Setup",
    description: "Launch your business on solid legal ground. We handle LLC formation, corporation setup, EIN acquisition, registered agent services, and operating agreements across all 50 states.",
    icon: "Building",
    features: [
      "LLC & Corporation filing",
      "EIN / Tax ID acquisition",
      "Registered agent service",
      "Operating agreement drafting"
    ]
  },
  {
    id: 4,
    title: "Trademark Search",
    subtitle: "Conflict Analysis & Clearance",
    description: "Before you invest in filing fees, find out if your brand is clear. We search USPTO records, state registries, common law sources, and business directories to flag potential conflicts early.",
    icon: "Search",
    features: [
      "Federal & state database search",
      "Common law usage analysis",
      "Phonetic & visual conflict check",
      "Risk assessment report"
    ]
  },
  {
    id: 5,
    title: "Amazon Brand Registry",
    subtitle: "Seller Brand Enrollment",
    description: "Get your brand enrolled in Amazon Brand Registry with our combined trademark-and-enrollment service. Unlock A+ Content, Sponsored Brands, and automated IP protection tools for your seller account.",
    icon: "Package",
    features: [
      "Brand Registry enrollment",
      "Trademark filing for Amazon",
      "A+ Content & Sponsored Brands access",
      "Brand protection tools setup"
    ],
    highlighted: true
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Essentials",
    price: "$49",
    period: "one-time",
    recommended: false,
    features: [
      "Case evaluation & review",
      "USPTO application filing",
      "Basic trademark search",
      "State e-filing included",
      "Email status updates"
    ],
    note: "USPTO govt. fee not included",
    buttonText: "Get Started"
  },
  {
    id: 2,
    name: "Growth",
    price: "$179",
    period: "one-time",
    recommended: false,
    features: [
      "Everything in Essentials",
      "Direct-hit conflict search",
      "Trademark monitoring alerts",
      "Refusal risk assessment",
      "Priority email support",
      "Application status dashboard"
    ],
    note: "USPTO govt. fee not included",
    buttonText: "Choose Growth"
  },
  {
    id: 3,
    name: "Professional",
    price: "$329",
    period: "one-time",
    recommended: true,
    features: [
      "Everything in Growth",
      "Comprehensive search report",
      "Dedicated case manager",
      "Office action response",
      "Trademark monitoring (1 yr)",
      "Complete documentation package",
      "Phone & email support"
    ],
    note: "USPTO govt. fee not included",
    buttonText: "Choose Professional"
  },
  {
    id: 4,
    name: "Enterprise",
    price: "$399",
    period: "one-time",
    recommended: false,
    features: [
      "Everything in Professional",
      "Full clearance search report",
      "Priority fast-track processing",
      "Cease & desist letter",
      "Trademark renewal reminder",
      "Multi-class filing support",
      "Dedicated attorney access",
      "Brand protection strategy"
    ],
    note: "USPTO govt. fee not included",
    buttonText: "Choose Enterprise"
  }
];

export const workProcess = [
  {
    id: 1,
    step: "01",
    title: "Discovery & Search",
    description: "Tell us about your brand. We run a thorough trademark search across federal, state, and common law databases, then deliver a clear conflict report so you know exactly where you stand."
  },
  {
    id: 2,
    step: "02",
    title: "Prepare & File",
    description: "Our attorneys draft your application with the right classifications, proper specimens, and complete documentation. We file directly with the USPTO and confirm your submission."
  },
  {
    id: 3,
    step: "03",
    title: "Monitor & Secure",
    description: "We track every stage of your application, handle office actions if they arise, and keep you updated until your registration certificate is in hand."
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Attorney-Led Expertise",
    description: "Every application is handled by licensed trademark professionals who understand USPTO requirements inside and out."
  },
  {
    id: 2,
    title: "Flat-Rate, No Surprises",
    description: "Know your total cost before you begin. No hidden fees, no hourly billing, no surprise charges at any stage."
  },
  {
    id: 3,
    title: "Dedicated Case Manager",
    description: "One person owns your file from start to finish. Real-time updates, direct access, responsive support."
  }
];

export const stats = [
  { value: "10,000+", label: "Trademarks Filed" },
  { value: "98%", label: "Approval Rate" },
  { value: "50", label: "States Covered" },
  { value: "24hr", label: "Response Time" }
];

export const industries = [
  "E-Commerce", "Technology", "Fashion & Apparel", "Food & Beverage",
  "Health & Wellness", "Real Estate", "Financial Services", "Entertainment",
  "SaaS & Software", "Retail", "Manufacturing", "Consulting"
];

export const comparisonData = [
  { feature: "Trademark Search", us: true, traditional: true, diy: false },
  { feature: "USPTO Filing", us: true, traditional: true, diy: true },
  { feature: "Office Action Response", us: true, traditional: true, diy: false },
  { feature: "Dedicated Case Manager", us: true, traditional: false, diy: false },
  { feature: "Flat-Rate Pricing", us: true, traditional: false, diy: true },
  { feature: "Amazon Brand Registry Help", us: true, traditional: false, diy: false },
  { feature: "Real-Time Status Updates", us: true, traditional: false, diy: false },
  { feature: "Avg. Cost", us: "$49-$399", traditional: "$1,500-$5,000", diy: "$250-$350" },
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Jenkins",
    role: "CEO, TechFlow",
    content: "We had been putting off trademark registration for years because the process seemed opaque and expensive. Trademark Logo Design made it painless. Our application went through without a single hitch.",
    rating: 5
  },
  {
    id: 2,
    name: "Michael Chen",
    role: "Founder, Elevate Retail",
    content: "The comprehensive search they ran saved us from a major conflict we didn't know existed. Their attorneys flagged it early and suggested the perfect pivot. Couldn't have asked for better guidance.",
    rating: 5
  },
  {
    id: 3,
    name: "Jennifer Rodriguez",
    role: "Amazon Seller",
    content: "Brand Registry enrollment felt impossible before I found these guys. They handled the trademark and the enrollment as one package. Within weeks I had full access to A+ Content and my sales jumped 30%.",
    rating: 5
  },
  {
    id: 4,
    name: "David Rossi",
    role: "Director, Apex Holdings",
    content: "I've worked with big-name law firms that charge five times as much and deliver half the service. The dedicated case manager alone makes Trademark Logo Design worth it.",
    rating: 5
  },
  {
    id: 5,
    name: "Amanda Stevens",
    role: "Small Business Owner",
    content: "Forming my LLC and registering my trademark at the same time saved weeks of coordination. One team, one process, done right. This is how legal services should work.",
    rating: 5
  },
  {
    id: 6,
    name: "Robert Wilson",
    role: "E-Commerce Entrepreneur",
    content: "Starting at $49, this was the smartest investment I've made for my brand. The federal protection means no one can touch my business name in any state. Total peace of mind.",
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: "What exactly does trademark registration protect?",
    answer: "Trademark registration protects brand identifiers: your business name, logo, slogan, or any distinctive mark that distinguishes your products or services. Federal registration with the USPTO gives you exclusive rights across all 50 states and the legal standing to stop unauthorized use."
  },
  {
    id: 2,
    question: "How long does it take to get a trademark registered?",
    answer: "The typical timeline is 8-12 months from filing to approval. The USPTO begins examination within 3-4 months. If approved, your mark is published for a 30-day opposition period before final registration. Our team handles all office actions promptly to keep things on track."
  },
  {
    id: 3,
    question: "What's included in the $49 Essentials package?",
    answer: "Essentials covers your case evaluation, USPTO application filing, a basic trademark search, and state e-filing. It's ideal for straightforward registrations with low conflict risk. USPTO government fees ($250-$350 per class) are paid separately."
  },
  {
    id: 4,
    question: "How are your packages different from each other?",
    answer: "Essentials ($49) handles basic filing. Growth ($179) adds conflict search and monitoring. Professional ($329) includes a dedicated case manager, office action response, and full documentation. Enterprise ($399) adds priority processing, multi-class support, and dedicated attorney access."
  },
  {
    id: 5,
    question: "Is a trademark search really necessary before filing?",
    answer: "Strongly recommended. A search examines USPTO records, state registrations, and common law usage to flag conflicts. Without it, you risk losing your non-refundable filing fees and months of time if a similar mark already exists."
  },
  {
    id: 6,
    question: "Do I need a registered trademark for Amazon Brand Registry?",
    answer: "Yes. Amazon requires either a pending or registered federal trademark. Our combined service handles both the USPTO filing and the Brand Registry enrollment so you can access A+ Content, Sponsored Brands, and IP protection tools."
  },
  {
    id: 7,
    question: "What happens if the USPTO rejects my application?",
    answer: "If the USPTO issues an office action, our team drafts a professional response with legal arguments to overcome the objection. Professional and Enterprise packages include this at no additional cost."
  },
  {
    id: 8,
    question: "Can I register a trademark as an individual?",
    answer: "Absolutely. You don't need a company to file. That said, forming an LLC first provides liability protection and aligns ownership for future business needs. We offer bundled packages for both."
  }
];
